import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import { FRONTEND_ROUTES, getFreePlayAchievementsApiPath, ROUTES_API } from '@/services/Constants';
import { processRequest } from '@/services/Api';
import { historyPush } from '@/services/History';
import * as achievementsActions from '../store/actions';
import { achievementsActionTypes } from '../store/constants';
import { getCategories } from '../store/selectors';

export default function* (): Generator {
	yield all([
		takeLatest(achievementsActionTypes.GET_CATEGORIES_REQUEST, handleGetCategoriesRequest),
		takeEvery(achievementsActionTypes.GET_ACHIEVEMENTS_REQUEST, handleGetAchievementsRequest),
	]);
}

export function* handleGetCategoriesRequest({ payload }: any) {
	try {
		const { categoryName } = payload || {};
		const { data } = yield call(processRequest, ROUTES_API.FREE_PLAY_CATEGORIES);

		yield put(achievementsActions.getCategoriesSuccess(data));

		if (data.length > 0) {
			const activeCategory = data.find((cat: any) => cat.name.toLowerCase() === categoryName);
			yield put(achievementsActions.setActiveCategoryId(activeCategory?.id || data[0]?.id));
		}
	} catch (e: any) {
		if (e.status === 403) {
			yield call(historyPush, FRONTEND_ROUTES.HOME);
			return;
		}
		yield put(achievementsActions.getCategoriesError(e.message));
		yield put(errorHandlerActions.handleError(e, 'page-blocking'));
	}
}

export function* handleGetAchievementsRequest(): Generator {
	try {
		const categories: ReturnType<typeof getCategories> = (yield select(getCategories)) as any;

		// Fetch all categories in parallel.
		const results: any[] = (yield all(
			categories.map((cat: any) =>
				call(processRequest, getFreePlayAchievementsApiPath(cat.id)),
			),
		)) as any[];

		const achievements = results.reduce((acc: any, { data }: any, index: number) => {
			const category = categories[index];
			acc[category.id] = { ...data, ...category };
			return acc;
		}, {});

		yield put(achievementsActions.getAchievementsSuccess(achievements));
	} catch (e: any) {
		yield put(achievementsActions.getAchievementsError(e.message));
		yield put(errorHandlerActions.handleError(e, 'notification'));
	}
}
